import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { Link } from "react-router-dom";
import cx from "classnames";

interface AdminDashboardCardProps {
  title: string;
  description: string;
  icon: {
    default: IconDefinition;
    hover?: IconDefinition;
  };
  to: string;
}

const AdminDashboardCard = ({
  title,
  description,
  icon,
  to,
}: AdminDashboardCardProps) => {
  const iconSwapClasses =
    "group-hover:opacity-0 group-focus-visible:opacity-0 group-active:opacity-0";
  const iconRevealClasses =
    "opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100 group-active:opacity-100";

  return (
    <Link
      to={to}
      className={cx(
        "group dashboard-item-card flex h-full bg-white border rounded-md p-4",
        "outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2",
      )}
    >
      <div className="relative z-[1] flex w-full min-w-0 items-start gap-3">
        <div
          className="relative flex h-10 w-10 flex-shrink-0 items-center justify-center pt-0.5"
          aria-hidden="true"
        >
          <FontAwesomeIcon
            icon={icon.default}
            className={cx(
              "dashboard-item-card-icon text-xl text-primary",
              icon.hover && ["absolute", iconSwapClasses],
            )}
          />
          {icon.hover && (
            <FontAwesomeIcon
              icon={icon.hover}
              className={cx(
                "dashboard-item-card-icon text-xl text-primary",
                iconRevealClasses,
              )}
            />
          )}
        </div>
        <div className="flex min-w-0 flex-1 flex-col gap-2">
          <span className="dashboard-item-card-title block text-base font-semibold text-balance">
            {title}
          </span>
          <span className="block text-sm leading-snug text-gray-600 line-clamp-2 text-pretty">
            {description}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default AdminDashboardCard;
